import { API } from 'app/utils/client';
import { IClient } from 'app/models';
import { CRUDService } from './api';

export class ClientService extends CRUDService<IClient> { }

const instance = new ClientService(API, 'v1/clients');
export default instance;
